import React from "react";
import { Routes, BrowserRouter, Route } from "react-router-dom";
import MainPage from "./MainPage";

const App = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route  path="/" element={<MainPage />} />
            </Routes>
        </BrowserRouter>
    );
};

export default App;
